import { apiClient } from "@/lib/api";
import { fetchAllPages } from "@/lib/fetchAllPages";
import type {
  SalesAgentDashboard,
  SalesAgentListAdminItem,
  SalesAgentMeAssociationItem,
} from "@/types";

/** Backend cap: GET /sales-agents `limit` le=200. */
const SALES_AGENTS_PAGE_SIZE = 200;

export const salesAgentService = {
  getMyDashboard: async (): Promise<SalesAgentDashboard> => {
    const response = await apiClient.get<SalesAgentDashboard>(
      "/sales-agents/me/dashboard",
    );
    return response.data;
  },

  getMyAssociations: async (): Promise<SalesAgentMeAssociationItem[]> => {
    const response = await apiClient.get<SalesAgentMeAssociationItem[]>(
      "/sales-agents/me/associations",
    );
    return response.data;
  },

  /** List sales agents (requires Permission.SALES_AGENTS_MANAGE_ANY). */
  listForAdmin: (): Promise<SalesAgentListAdminItem[]> =>
    fetchAllPages(async (page) => {
      const response = await apiClient.get<SalesAgentListAdminItem[]>(
        "/sales-agents",
        { params: page },
      );
      return response.data;
    }, SALES_AGENTS_PAGE_SIZE),
};
